export default __webpack_public_path__ + "static/media/Aetna dark.f93216d3.svg";